import { Stack } from '@pairy/pds-react';

import BulkEditCtaBanner from '@/components/User/_components/pdf/BulkLinkCopySection/BulkEditCtaBanner';

import ProPlanUpgradeBanner from '../../common/banner/ProPlanUpgradeBanner';

import BulkCtaBanner from './BulkCtaBanner';
import BulkLinkCopyAccordion from './BulkLinkCopyAccordion';
import GmailBox from './GmailBox';

interface Props {
  fileName?: string;
  fileThumbnail?: string;
  isShowBanner?: boolean;
}

const BulkLinkCopySection = ({
  fileName,
  fileThumbnail,
  isShowBanner = false,
}: Props) => {
  return (
    <Stack gap={32} direction="column">
      <Stack gap={16} direction="column">
        {fileName && fileThumbnail && (
          <BulkEditCtaBanner
            fileName={fileName}
            fileThumbnail={fileThumbnail}
          />
        )}
        <BulkCtaBanner />
      </Stack>
      {isShowBanner && <ProPlanUpgradeBanner />}
      <GmailBox />
      <BulkLinkCopyAccordion />
    </Stack>
  );
};

export default BulkLinkCopySection;
